module.exports = __webpack_public_path__ + "img/time.5de1a092.svg";